<template>
    <div>
        <p class="slds-p-bottom_small">
            Here are headers we found in your CSV. Please fill out the required fields for use in Maps.
        </p>
        <div class="slds-grid">
            <div class="table-container slds-col slds-size_1-of-1">
                <table class="slds-table">
                    <thead id="data-column-header">
                        <tr class="slds-line-height_reset slds-border_bottom">
                            <th
                                class="slds-text-title_caps slds-cell-buffer_left slds-cell-buffer_right"
                                scope="col"
                            >
                                <div class="slds-truncate">
                                    <abbr
                                        class="slds-required"
                                        title="required"
                                    >*</abbr>Active
                                </div>
                            </th>
                            <th
                                class="slds-text-title_caps slds-cell-buffer_left slds-cell-buffer_right"
                                scope="col"
                            >
                                <div class="slds-truncate">
                                    <abbr
                                        class="slds-required"
                                        title="required"
                                    >*</abbr>Header Name
                                </div>
                            </th>
                            <th
                                class="slds-text-title_caps slds-cell-buffer_left slds-cell-buffer_right"
                                scope="col"
                            >
                                <div class="slds-truncate">
                                    <abbr
                                        class="slds-required"
                                        title="required"
                                    >*</abbr>Format As
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody id="data-columns">
                        <tr
                            v-for="column in store__schema"
                            :key="column.index"
                            class="slds-hint-parent"
                        >
                            <td class="slds-grid slds-grid--align-center slds-cell-buffer_left slds-form-element">
                                <MACheckbox
                                    v-model="column.active"
                                    :isDisabled="column.spatial != null"
                                    :value="column.active"
                                    noSlide
                                />
                            </td>
                            <td class="slds-cell-buffer_left slds-cell-buffer_right slds-form-element">
                                <MAInput
                                    v-model="column.renamedLabel"
                                    :isRequired="true"
                                    class="slds-form-element"
                                    :value="column.rawLabel"
                                />
                            </td>
                            <td class="slds-cell-buffer_left slds-cell-buffer_right slds-form-element">
                                <MAPicklist
                                    v-model="column.format"
                                    :isDisabled="column.spatial != null"
                                    :isRequired="true"
                                    :hasNoneOption="false"
                                    keyString="key"
                                    valueString="value"
                                    :options="formatAsOptions"
                                    doDetach="true"
                                    placeholder="Format As..."
                                    class="slds-form-element__control"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import MAInput from '@mapanything/ma-lib/src/vue/components/MAInput.vue';
import MAPicklist from '@mapanything/ma-lib/src/vue/components/MAPicklist.vue';
import MACheckbox from '@mapanything/ma-lib/src/vue/components/MACheckbox.vue';

export default {
    name: 'DataColumns',
    components: {
        MAInput,
        MAPicklist,
        MACheckbox
    },
    data() {
        return {
            formatAsOptions: [
                {
                    key: 'url',
                    value: 'URL'
                },
                {
                    key: 'decimal',
                    value: 'Decimal'
                },
                {
                    key: 'boolean',
                    value: 'Boolean'
                },
                {
                    key: 'currency',
                    value: 'Currency'
                },
                {
                    key: 'string',
                    value: 'Text'
                },
                {
                    key: 'date',
                    value: 'Date'
                },
                {
                    key: 'integer',
                    value: 'Integer'
                }
            ],
            isVisible: false
        };
    },
    computed: {
        ...mapState({
            cache: false,
            store__dataset: 'dataset',
            store__schema: 'schema',
            store__spatialReference: 'spatialReference'
        }),
        schemaLength() {
            return this.store__schema.length;
        }
    },
    mounted() {
        this.reassignSpatialIndexes();
    },
    methods: {
        ...mapMutations({
            store__updateSchemaElement: 'updateSchemaElement'
        }),
        reassignSpatialIndexes() {
            Object.values(this.store__spatialReference).forEach((_spatialReference) => {
                if (_spatialReference.index != null) {
                    this.store__updateSchemaElement(_spatialReference);
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .table-container {
        border: 1px solid #dddbda;
        border-radius: .25rem;
        overflow: hidden;
    }

    #data-columns .slds-form-element {
        margin-bottom: .25rem;
        margin-top: .25rem;
    }
</style>
